import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Linkify from 'linkify-react';
import { Button, Typography, colors } from '@sweep-io/sweep-design';
import { TruncatedTextTooltip } from '../../../../common/TruncatedTextTooltip';
import { DotDivider } from '../../../../common/DotDivider';
import { DetailsWrapperWithHeader } from './DetailsWrapperWithHeader';

const DETAILS_TEXT_COLOR = colors.grey[700];

export const DetailsItem = ({
  headerTxt,
  contentTxt,
  isMandatory,
}: {
  headerTxt: string;
  contentTxt: string;
  isMandatory?: boolean;
}) => (
  <DetailsWrapperWithHeader headerTxt={headerTxt}>
    <Linkify
      options={{
        target: 'blank',
        validate: {
          url: (value) =>
            /\b(?:https?:\/\/(?:www\.)?|www\.)[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}\b/.test(
              value,
            ),
        },
        render: ({ attributes, content }) => {
          const { href } = attributes;
          return (
            <Box display="inline-flex" alignItems="center">
              <Button variant="flat-blue" size="tiny" onClick={() => window.open(href, '_blank')}>
                {content}
              </Button>
            </Box>
          );
        },
      }}
    >
      <Stack direction="row" alignItems="center" minWidth={0}>
        <TruncatedTextTooltip title={contentTxt} variant="caption" color={DETAILS_TEXT_COLOR}>
          {contentTxt}
        </TruncatedTextTooltip>

        {isMandatory ? (
          <>
            <Box component="span" sx={{ margin: '0 8px' }}>
              <DotDivider dotColor={colors.grey[700]} />
            </Box>
            <Typography variant="caption" color={colors.blush[600]}>
              Mandatory
            </Typography>
          </>
        ) : (
          ''
        )}
      </Stack>
    </Linkify>
  </DetailsWrapperWithHeader>
);
